<ng-container *transloco="let t; read: 'header'">
  <div class="top-navbar">
    <div class="navbar-content">
      <span class="flex-1"></span>
      <a href="javascript:;" class="user-info" (click)="showRightSidebar.set(true)">
        <span class="user-name">{{ userName }}</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.99967 1.33203C4.31967 1.33203 1.33301 4.3187 1.33301 7.9987C1.33301 11.6787 4.31967 14.6654 7.99967 14.6654C11.6797 14.6654 14.6663 11.6787 14.6663 7.9987C14.6663 4.3187 11.6797 1.33203 7.99967 1.33203ZM4.89967 12.332C5.77301 11.7054 6.83967 11.332 7.99967 11.332C9.15967 11.332 10.2263 11.7054 11.0997 12.332C10.2263 12.9587 9.15967 13.332 7.99967 13.332C6.83967 13.332 5.77301 12.9587 4.89967 12.332ZM12.093 11.412C10.9663 10.532 9.54634 9.9987 7.99967 9.9987C6.45301 9.9987 5.03301 10.532 3.90634 11.412C3.13301 10.4854 2.66634 9.2987 2.66634 7.9987C2.66634 5.05203 5.05301 2.66536 7.99967 2.66536C10.9463 2.66536 13.333 5.05203 13.333 7.9987C13.333 9.2987 12.8663 10.4854 12.093 11.412Z" fill="#003765"/>
          <path d="M7.99967 3.9987C6.71301 3.9987 5.66634 5.04536 5.66634 6.33203C5.66634 7.6187 6.71301 8.66536 7.99967 8.66536C9.28634 8.66536 10.333 7.6187 10.333 6.33203C10.333 5.04536 9.28634 3.9987 7.99967 3.9987ZM7.99967 7.33203C7.44634 7.33203 6.99967 6.88536 6.99967 6.33203C6.99967 5.7787 7.44634 5.33203 7.99967 5.33203C8.55301 5.33203 8.99967 5.7787 8.99967 6.33203C8.99967 6.88536 8.55301 7.33203 7.99967 7.33203Z" fill="#003765"/>
        </svg>
      </a>
    </div>
  </div>

  <div class="bottom-navbar">
    <div class="navbar-content">
        <img class="header-logo" [src]="logo$|async" alt="logo">
        <ul class="menu-wrapper">
          @for (link of links$ | async; track $index) {
            @if (link.url) {
              <li><a [href]="formatUrlWithLangCode(link.url)">{{t(link.label)}}</a></li>
            }
            @if (link.route) {
              <li>
                <a
                  [routerLink]="link.route"
                  [queryParams]="{ langCode: currentLangCode }"
                  [state]="link.state"
                >{{t(link.label)}}</a>
              </li>
            }
          }
        </ul>
        <span class="flex-1"></span>
        <span (click)="showRightSidebar.set(true)" class="mobile-burger-menu">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 32V29.3333H36V32H12ZM12 25.3333V22.6667H36V25.3333H12ZM12 18.6667V16H36V18.6667H12Z" fill="#003765"/>
          </svg>
        </span>
    </div>
  </div>

  <div [class.open]="showRightSidebar()" class="right-sidebar">
    <app-right-sidebar />
  </div>
</ng-container>
